<template>
  <b-container>
    <b-modal id="modal-mail" :title="this.modalTitle" @ok="onSubmit" ok-title="Mail" @hide="onHide" @cancel="onHide">
      <form ref="form">
        <b-form-group id="mail">
          <label for="mail-subject">Email subject:</label>
          <b-form-input
            id="mail-subject"
            v-model="mailHeader"
            placeholder="Email subject"
          ></b-form-input>
          <label for="mail-body">Email body:</label>
          <b-form-textarea
            id="mail-body"
            v-model="mailBody"
            placeholder="Email body"
            rows="5"
          ></b-form-textarea>
        </b-form-group>
      </form>
      <template v-slot:modal-footer="{ cancel, ok }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()" :disabled='!(emptyMailChecker)'>
          Mail
        </b-button>
      </template>     
    </b-modal>
  </b-container>
</template>

<script>
import {db} from '@/firebase/init';

export default {
  data: () => ({
      modalTitle: "Mail your subscribers",
      mailHeader: "",
      mailBody: "",
  }),
  computed: {
    emptyMailChecker() {
      // console.log(this.mailHeader)
      // console.log(this.mailBody)
      return (this.mailHeader != "" && this.mailBody != "")
    }
  },
  methods:{
    onHide() {
      this.mailHeader = "";
      this.mailBody = "";
    },
    onSubmit(){
      // console.log("send mail is called");
      db.collection("updateEmail").doc(this.mailHeader).set({
      message: this.mailBody,
      subject: this.mailHeader
      }).then(()=>{
        // console.log("Sending Email")
      }).catch((err)=>{
        // console.log("ERROR");
        throw err;
      })
    }
  }
}
</script>